import get from 'lodash/get';

import {
  FIRST_NAME_DATA_STANDARDS,
  LAST_NAME_DATA_STANDARDS,
} from 'jl-design-system/form/fields';
import getAddressFieldsConfig from 'jl-design-system/form/configs/address';
import { getPhoneNumberDropdownOptions } from '../../address/addressHelpers';
import { internationalPhoneNumberLazy } from '../../lazy/lazyMainBundle';

const INTERNATIONAL_PHONE_NUMBER = internationalPhoneNumberLazy;

export const APPLE_PAY_BILLING_ADDRESS_FORM_ID = 'applePayBillingDetailsForm';
export default function getApplePayBillingDetailsFormConfig(params) {

  const {
    countryCode,
    addressLines,
    maxAddressLines,
    actions,
    configExtras,
  } = params;

  const {
    isClickCollectOrder,
    submitButtonExtra,
  } = configExtras;

  const ADDRESS_FIELDS = getAddressFieldsConfig({
    countryCode,
    addressLines,
    maxAddressLines,
    actions,
    configExtras,
    allowAsciiOnly: true,
  });

  // TODO move this into a helper so it can be reused across multiple form configs
  const config = INTERNATIONAL_PHONE_NUMBER();
  const PHONE_NUMBER = get(config, 'component') ? {
    ...config,
    props: {
      options: getPhoneNumberDropdownOptions(),
    },
    instruction: isClickCollectOrder ?
      'We’ll use this number to send text updates or if we have any queries with your order' :
      'We’ll use this number if we have any queries with your payment',
  } : config;

  return {
    submitButton: 'Continue with payment',
    submitButtonExtra,
    id: APPLE_PAY_BILLING_ADDRESS_FORM_ID,
    fields: [
      FIRST_NAME_DATA_STANDARDS,
      LAST_NAME_DATA_STANDARDS,
      PHONE_NUMBER,
      ...ADDRESS_FIELDS,
    ],
  };
}
